module.exports = window["braintree"]["paypalCheckout"];